import { TagsAccordion } from "./TagsAccordion";

import styles from "./SubHeader.module.scss";

export const SubHeader = (props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.bg} />

      {!props.hideTags && <TagsAccordion {...props} />}
    </div>
  );
};
